/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Homepagenext from "components/Homepage/Homepagenext";

export default function Index() {
  return (
    <section className="relative overflow-hidden">
      {/* <IndexNavbar fixed /> */}
      <Homepagenext/>
    </section>
  );
}
